<div class="accordion-item">
    <h3 class="accordion-header" id="headingOne">
        <button class="accordion-button" (click)="showContact = !showContact" [ngClass]="{'collapsed':!showContact}"
            type="button" data-bs-toggle="collapse" data-bs-target="#INSCD" aria-expanded="true" aria-controls="INSCD">
            <span>Contact Details</span>
            <div class="arrow"></div>
        </button>
    </h3>
    <div *ngIf="contactForm" id="INSCD" class="accordion-collapse collapse" [ngClass]="{'show':showContact}"
        [formGroup]="contactForm" aria-labelledby="INSCD">
        <div class="accordion-body">

            <div class="row">

                <div class="col-3 mb-3">
                    <label for="insFName" class="form-label">First Name<span class="mandatory">*</span></label>
                    <input autocomplete="disabled" type="text" id="insFName" formControlName="firstName" class="form-control"
                        [ngClass]="{'is-invalid' : formSubmitted && contactForm?.controls?.['firstName']?.errors?.['required']}" appPreventFirstSpace>
                    <span *ngIf="formSubmitted && contactForm?.controls?.['firstName']?.errors?.['required']"
                        class="invalid-feedback d-block" tabindex="0">This field is required</span>
                </div>

                <div class="col-3 mb-3">
                    <label for="insMName" class="form-label">Middle Name</label>
                    <input autocomplete="disabled" type="text" id="insMName" formControlName="middleName" class="form-control"
                        [ngClass]="{'is-invalid' : formSubmitted && contactForm?.controls?.['middleName']?.errors?.['required']}" appPreventFirstSpace>
                    <span *ngIf="formSubmitted && contactForm?.controls?.['middleName']?.errors?.['required']"
                        class="invalid-feedback d-block" tabindex="0">This field is required</span>
                </div>

                <div class="col-3 mb-3">
                    <label for="insLName" class="form-label">Last Name</label>
                    <input autocomplete="disabled" type="text" id="insLName" formControlName="lastName" class="form-control"
                        [ngClass]="{'is-invalid' : formSubmitted && contactForm?.controls?.['lastName']?.errors?.['required']}" appPreventFirstSpace>
                    <span *ngIf="formSubmitted && contactForm?.controls?.['lastName']?.errors?.['required']"
                        class="invalid-feedback d-block" tabindex="0">This field is required</span>
                </div>
                <div class="col-3 mb-3">
                    <label for="insPosition" class="form-label">Position<span class="mandatory">*</span></label>
                    <input autocomplete="disabled" type="text" id="insPosition" formControlName="position" class="form-control"
                        [ngClass]="{'is-invalid' : formSubmitted && contactForm?.controls?.['position']?.errors?.['required']}" appPreventFirstSpace>
                    <span *ngIf="formSubmitted && contactForm?.controls?.['position']?.errors?.['required']"
                        class="invalid-feedback d-block" tabindex="0">This field is required</span>
                </div>
                <div class="col-3 mb-3">
                    <label for="INSPNumber1" class="form-label">Contact No.<span class="mandatory">*</span></label>
                    <div class="phone-number" id="contactNumber">
                    <div tabindex="0" class="ngx-dropdown-container">
                        <app-select-dropdown [label]="'phoneCode'" placeholder="Select" [multiple]="false"
                            [isClearable]="false" [combineDisplay]="'countryName'" [showImage]="true"
                            [imageURL]="'countryFlag'" [options]="phoneCodes" [singleSelect]="true" [search]="true"
                            id="phoneCode" formControlName="phoneCode">
                        </app-select-dropdown>
                    </div>
                    <input type="text" id="INSPNumber1" formControlName="contactNumber" class="form-control" [ngClass]="{'is-invalid' : (formSubmitted && contactForm?.controls?.['contactNumber']?.errors?.['required']) ||
                    (contactForm?.controls?.['contactNumber']?.errors?.['onlyNumber'])}" appPreventFirstSpace>
                
                    <span *ngIf=" (contactForm?.controls?.['contactNumber']?.errors?.['onlyNumber'])"
                        class="invalid-feedback d-block" tabindex="0">Contact Number should be Number</span>
                    <span *ngIf="formSubmitted && contactForm?.controls?.['contactNumber']?.errors?.['required']"
                        class="invalid-feedback d-block" tabindex="0">This field is required</span>
                </div>
                </div>

                <div class="col-6 mb-3">
                    <label for="insContactEmail{{uniQueId}}" class="form-label">Contact Email<span class="mandatory">*</span></label>
                    <input autocomplete="disabled" type="text" id="insContactEmail{{uniQueId}}" formControlName="contactEmail" class="form-control" [readonly]="isEdit"
                        [ngClass]="{'is-invalid' : (formSubmitted && contactForm?.controls?.['contactEmail']?.errors?.['required']) ||
                    (formSubmitted && contactForm?.controls?.['contactEmail']?.errors?.['email']),'disabled':isEdit}" appPreventFirstSpace>
                    <span *ngIf="formSubmitted && (contactForm?.controls?.['contactEmail']?.errors?.['email'])"
                        class="invalid-feedback d-block" tabindex="0">Enter Valid Email</span>
                    <span *ngIf="formSubmitted && contactForm?.controls?.['contactEmail']?.errors?.['required']"
                        class="invalid-feedback d-block" tabindex="0">This field is required</span>
                </div>
                <ng-container >
                <div class="col-12" *ngIf="isUser == null">
                    <div class="form-check d-flex mb-3" >
                        <input autocomplete="disabled" class="form-check-input" type="checkbox" formControlName="isUser" [checked]="isChecked"
                            (change)="checkUser($event)" id="InsSet" name="deliveryItems" >
                        <label class="form-check-label link" for="InsSet">Set as user</label>
                    </div>
                </div>
                <div class="col-12" >
                    <div class="tariff-form mb-3">
                        <div class="row">
                            <div class="col-3">
                                <label for="INSUserName" class="form-label">User Name<span class="mandatory"
                                        *ngIf="formSubmitted && isChecked && !(contactForm?.controls?.['userName']?.errors?.['email']) && !(contactForm?.controls?.['userName']?.value)">*</span></label>
                                <input autocomplete="disabled" type="text" id="INSUserName{{uniQueId}}" formControlName="userName" class="form-control "
                                    [ngClass]="{'is-invalid' : (formSubmitted && isChecked && !(contactForm?.controls?.['userName']?.value)) ||
                    (formSubmitted && contactForm?.controls?.['userName']?.errors?.['email']) }" appPreventFirstSpace>
                                <span *ngIf="formSubmitted && (contactForm?.controls?.['userName']?.errors?.['email'])"
                                    class="invalid-feedback d-block" tabindex="0">Enter Valid Email</span>
                                <span
                                    *ngIf="formSubmitted && isChecked && !(contactForm?.controls?.['userName']?.errors?.['email'])&& !(contactForm?.controls?.['userName']?.value)"
                                    class="invalid-feedback d-block" tabindex="0">This field is required</span>
                            </div>
                            <div class="col-3">
                                <label for="INSPassword" class="form-label">Password<span class="mandatory"
                                        *ngIf="(formSubmitted && isChecked  && !(contactForm?.controls?.['password']?.value)) ">*</span></label>
                                <input autocomplete="disabled" type="password" id="INSPassword" formControlName="password" class="form-control"
                                    [ngClass]="{'is-invalid' : (formSubmitted && isChecked  && !(contactForm?.controls?.['password']?.value)) ||
                    (formSubmitted && contactForm?.controls?.['password']?.errors?.['passwordRule']) }" appPreventFirstSpace>
                                <span
                                    *ngIf="formSubmitted && (contactForm?.controls?.['password']?.errors?.['passwordRule'])"
                                    class="invalid-feedback d-block" tabindex="0">Password must be at least 8 characters
                                    that include one upper case,number and special character</span>
                                <span
                                    *ngIf="formSubmitted && isChecked && !(contactForm?.controls?.['password']?.errors?.['passwordRule']) && !(contactForm?.controls?.['password']?.value)"
                                    class="invalid-feedback d-block" tabindex="0">This field is required</span>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
            </div>
        </div>
    </div>
</div>